(function($) {
    function fillProgressBar() {
        var $bar = $(".progress");
        var width = 0;
        var delayTime = 1500;
        var duration = 3500;
        var split = duration / 100;
        setTimeout(function() {
            var interval = setInterval(function() {
                width++;
                $bar.css("width", width + "%");
                if (width >= 100) {
                    clearInterval(interval);
                    $bar.css("opacity", 0)
                }
            }, split);
        }, delayTime);

    }
    $(document).ready(function() {

        var $slider = $('.hero-slider');
        $slider.on('init afterChange', function() {
            $(".progress").css("opacity", 1);
            $(".progress").css("width", '0%');
            fillProgressBar();
        });


        $slider.slick({
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            speed: 1500,
            rows: 0,
        });
    });

})( jQuery );